<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>CAMBIAR TURNO</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-3">
            <h6>SELECCIONA UNA PERSONA PARA ASIGNARLE EL TURNO EN LA SIGUIENTE SEMANA:</h6>
          </div>
          </div>
        <div class="row ml-3 mt-4">
          <div class="col-12">
            <h6>DESDE: {{fechaInicio.split('-')[2]+'-'+fechaInicio.split('-')[1]+'-'+fechaInicio.split('-')[0]}}</h6>
          </div>
          <div class="col-12">
            <h6>HASTA: {{fechaFin.split('-')[2]+'-'+fechaFin.split('-')[1]+'-'+fechaFin.split('-')[0]}}</h6>
          </div>
        </div>
      </div>
      <ion-item class="mt-3">
        <ion-label position="stacked">USUARIOS DEL TURNO</ion-label>
        <select class="form-control mt-2" cancel-text="CANCELAR" ok-text="ACEPTAR" v-model="usrSeleccionado">
          <option class="opt" value="" disabled selected>SELECCIONA UNO</option>
          <option class="opt" v-for="usuario in usuarios" :value="usuario.rut" :key="'usr'+usuario.rut">{{usuario.nombre}}</option>
        </select>
      </ion-item>
      
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="cambiarUsuarioTurno();" color="success" shape="round" expand="block">
                <ion-label>GUARDAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonSpinner, IonList, toastController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';

export default defineComponent({
  name: 'ModalCambiarUsuarioTurno',
  props: {
    usuarios    : Array,
    fechaInicio : String,
    fechaFin    : String,
    idTurno     : String
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonSpinner, IonList },
  data(){
    return {
      cargando          : false,
      usrSeleccionado   : ''
    }
  },
  methods:{
    async cambiarUsuarioTurno(){
      this.cargando = true;
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('id_turno'    , this.idTurno || '');
      dato.append('rut'         , this.usrSeleccionado);
      dato.append('fecha_inicio', this.fechaInicio || '');
      dato.append('fecha_fin'   , this.fechaFin || '');
      axios.post(rutaBase+'/turnos/cambiarUsuarioTurno', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('DATOS REGISTRADOS CORRECTAMENTE.');
          this.cerrarModal({recargar:true});
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR TURNO.');
      });
    },

    validaDatos(){
      if(
        this.usrSeleccionado == ''
      ){
        return false;
      }
      else {
        return true;
      }
    },

    async cerrarModal(dato={recargar:false}){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>